import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Col, Heading } from '@thd-olt-component-react/core-ui';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Pill } from './Pill';
import './related-categories.scss';
import { track } from './related-categories-analytics';

export function RelatedCategories({ categories, noOfItems }) {
  const { channel } = useContext(ExperienceContext);

  const validCategories = categories.filter(
    (category) => category?.pageTitle && category?.canonicalUrl
  ).slice(0, noOfItems);

  if (!validCategories.length) return null;

  return (
    <div className="related-categories">
      <Col>
        <Heading centered={channel !== 'mobile'} underline title="Related Categories" />
        <div className="related-categories__links">
          {validCategories.map(
            ({ categoryId, pageTitle, canonicalUrl }) => {
              return (
                <Pill
                  key={categoryId}
                  text={pageTitle}
                  link={canonicalUrl}
                  onClick={() => track(pageTitle)}
                />
              );
            }
          )}
        </div>
      </Col>
    </div>
  );
}

RelatedCategories.defaultProps = {
  categories: [],
  noOfItems: 10
};

const Categories = PropTypes.shape({
  categoryId: PropTypes.string,
  pageTitle: PropTypes.string,
  canonicalUrl: PropTypes.string
});

RelatedCategories.propTypes = {
  categories: PropTypes.arrayOf(Categories),
  noOfItems: PropTypes.number
};